/* eslint-disable */
import styles from './index.module.scss'
import { Link } from 'react-router-dom'
import text from './text.json'
import { ButtonArrow } from '../../../../icons'
import { PageContext } from '../../../../context/PageContextProvider'
import { useContext } from 'react'

const DetailsCard = ({ img, title, description, to }) => {
  const { language } = useContext(PageContext)
  return (
    <div className={`${styles.container} bpg-card-neon`}>
      <figure>
        <img src={img} alt={title || 'BPG Consulting'} loading="lazy" />
      </figure>
      <div>
        <div>
          <h3>{title}</h3>
          <p
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        </div>

        <Link to={to}>
          {text.button?.[language] || text.button?.TR || text.button?.AZ} <ButtonArrow />
        </Link>
      </div>
    </div>
  )
}

export default DetailsCard
